import { z } from 'zod';

import { CustomQuestionScope } from './custom-questions';

export const BookingFormSchema = z.object({
  scope: z.nativeEnum(CustomQuestionScope),
  fields: z.object({
    emailAddress: z.object({
      isRequired: z.boolean(),
      isActive: z.boolean(),
    }),
    phoneNumber: z.object({
      isRequired: z.boolean(),
      isActive: z.boolean(),
    }),
  }),
});

export const ExperienceSettingsSchema = z.object({
  bookingForm: z.array(BookingFormSchema).optional(),
  isCurated: z.boolean().optional(),
});
